import { makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { DefaultInputProps } from '../../types/types';
import { globalStyles } from '../../style/GlobalStyles';
import { SectionTitle } from '../../components/SectionTitle';
import { NumberField } from '../../components/NumberField';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function IrpefCollaboratore1(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;

    return (
        <React.Fragment>
            {state.datiCollaboratore1.nomeCognome1 !== undefined && state.datiCollaboratore1.nomeCognome1 !== "" ?
                (<Paper className={gClasses.mainPaper}>
                    <SectionTitle text="Collaboratore 1"></SectionTitle>
                    <TextField
                        label="Collaboratore 1"
                        value={state.datiCollaboratore1.nomeCognome1}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{tabIndex: -1}}
                        margin="normal"
                    />
                    <NumberField
                        name=""
                        label="Contr. IVS"
                        value={state.irpefCollaboratore1.H35}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Redditi</Typography>
                    <NumberField
                        name=""
                        label="Pensione"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E111}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lav. dipendente e assimilati"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E112}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Assimilati lav. dipendente"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E113}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Partecipazione Impresa famigliare"
                        value={state.datiCollaboratore1.altriDatiPersonali_J118}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Diversi lettere i) e l)"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E114}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Fabbricati locati"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E115}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Altri"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E116}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Abitazione principale"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E117}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Redditi a cedolare secca"
                        value={state.datiCollaboratore1.redditiDiversiDallaPartecipazione_E119}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Reddito complessivo"
                        value={state.irpefCollaboratore1.E48}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Redd. compl. per detraz."
                        value={state.irpefCollaboratore1.E49}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Oneri deducibili"
                        value={state.irpefCollaboratore1.I37}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Reddito imponibile"
                        value={state.irpefCollaboratore1.I38}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Irpef lorda"
                        value={state.irpefCollaboratore1.I39}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Detrazioni</Typography>
                    <NumberField
                        name=""
                        label="Familiari a carico"
                        value={state.irpefCollaboratore1.I41}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lavoro dipend."
                        value={state.irpefCollaboratore1.I42}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Pensione"
                        value={state.irpefCollaboratore1.I43}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lav. non dipend."
                        value={state.irpefCollaboratore1.I44}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Altre"
                        value={state.datiCollaboratore1.altriDatiPersonali_L115}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Tot. Detrazioni"
                        value={state.irpefCollaboratore1.I46}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Irpef netta"
                        value={state.irpefCollaboratore1.M42}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Addizionali Irpef</Typography>
                    <NumberField
                        name=""
                        label="Regionale"
                        value={state.irpefCollaboratore1.K46}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Comunale"
                        value={state.irpefCollaboratore1.M46}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </Paper>) : <p></p>}
        </React.Fragment>
    );
}